import { CustomFieldRendererProps } from "@/components/custom-field/edit/custom-field-edit.type.ts";
import { useRecent } from "@/hooks/use-recent.hook.ts";
import { useCurrencies } from "@/queries/currencies.query.ts";
import { ApiRecentKey } from "@/types/recents/recents.types.ts";
import { CustomFieldCurrency, SelectItem } from "@skailer-com/uikit";
import { useMemo } from "react";

export function CustomFieldEditCurrency(props: CustomFieldRendererProps) {
  const { data: currencies, isLoading } = useCurrencies();
  const { getRecentOptions } = useRecent();
  const currencyOptions = useMemo<SelectItem[]>(
    () => currencies?.map((currency) => ({ id: currency.code, title: currency.code })) ?? [],
    [currencies]
  );

  return (
    <CustomFieldCurrency
      {...props}
      currencyOptions={currencyOptions}
      currencyRecentOptions={getRecentOptions(ApiRecentKey.currency, currencyOptions)}
      isCurrencyLoading={isLoading}
    />
  );
}
